// import something here
import lodash from 'lodash'; // "async" is optional;
// more info on params: https://quasar.dev/quasar-cli/cli-documentation/boot-files#Anatomy-of-a-boot-file

export default (function (_ref) {
  var Vue = _ref.Vue;
  // _ = lodash global
  Vue.prototype._ = lodash;
});